var scope_0 = require('D:/Projects/gatsby-theme-courses/gatsby-theme-courses/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;export default
        Object.assign({}, scope_0 )
    